import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a41bdd38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-email" }
const _hoisted_2 = { class: "text-rt commit mt_90" }

import { ref, reactive } from 'vue'
import { t } from '@/plugins/i18n'
import { changeEmail as createRules } from '@/views/signup/components/rules'
import { useGetCode, useLoading } from '@/views/signup/components/utils'
import useForm from '@/util/useForm'
import { getChangeEmailCode, addEmail, updateEmail } from '@/apis/login'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import md5 from 'md5'


export default /*#__PURE__*/_defineComponent({
  props: ['customer'],
  emits: ['cancel', 'update'],
  setup(__props, { emit }) {

const props = __props


const store = useStore()

const texts = ['密码', '新邮箱地址', '验证码']
const tips = ['输入你的登陆密码', '输入邮箱', '输入验证码']

const pwc = ref(true)
const request = props.customer.customerEmail ? updateEmail : addEmail as any
const [loading, api] = useLoading(request)
const { count, tip, disabled, getCode } = useGetCode(
  'changeEmailCode1',
  getChangeEmailCode
)

const form: any = reactive({
  password: '',
  newCustomerEmail: '',
  verificationCode: ''
})
const rules = createRules(form, disabled)

const [formRef, commit] = useForm(() => {
  // console.log(customer.accountType)
  const formData = {
    ...form,
    password: md5(form.password)
  }
  if (props.customer.accountType !== 1) {
    // 子账号传customerId
    formData.customerId = props.customer.customerId
  }
  api(formData).then((res) => {
    if (res && res.success) {
      ElMessage.success(t('修改邮箱成功'))
      emit('cancel')
      emit('update', form.newCustomerEmail)
      store.dispatch('route/changeToken', store.getters.token)
    }
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['formRef'] = _value
        _isRef(formRef) && (formRef.value = _value)
      },
      model: _unref(form),
      rules: _unref(rules),
      "label-width": "170px",
      "label-position": "left"
    }, {
      default: _withCtx(() => [
        (!__props.customer.initialPassword)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              prop: "password",
              label: _unref(t)(texts[0])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: pwc.value ? 'password' : 'text',
                  modelValue: _unref(form).password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).password) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: _unref(t)(tips[0]),
                  maxlength: 32,
                  style: {"width":"304px","height":"34px"},
                  name: "validpassword"
                }, null, 8, ["type", "modelValue", "placeholder"]),
                _createElementVNode("i", {
                  class: _normalizeClass(["abs btn eye primary fa", pwc.value ? 'fa-eye-slash' : 'fa-eye']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (pwc.value = !pwc.value))
                }, null, 2)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          prop: "newCustomerEmail",
          label: _unref(t)(texts[1])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "email",
              modelValue: _unref(form).newCustomerEmail,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).newCustomerEmail) = $event)),
              modelModifiers: { trim: true },
              placeholder: _unref(t)(tips[1]),
              maxlength: 50,
              style: {"width":"304px","height":"34px"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          prop: "verificationCode",
          label: _unref(t)(texts[2])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "text",
              style: {"width":"194px","height":"34px"},
              modelValue: _unref(form).verificationCode,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).verificationCode) = $event)),
              modelModifiers: { trim: true },
              placeholder: _unref(t)(tips[2]),
              maxlength: 6
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_el_button, {
              class: "codebtn",
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(getCode)(_unref(form).newCustomerEmail))),
              disabled: _unref(count) > 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(count) >
          0 ? _unref(tip) : _unref(t)('获取验证码')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        class: "light",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        class: "dark",
        onClick: _unref(commit),
        loading: _unref(loading)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ])
  ]))
}
}

})